import React, {useEffect, useState} from 'react';
import { Form, Input, Row, Col, Tabs } from 'antd'
import {  TabDados,
          TabTributacao,
          TabBalancas,
          TabECommerce,
          TabNucardapio,
          TabEstoque,
          TabComposicao,
          TabOutrasInformacoes,
          TabOpcoesPDV
        } from './tabs';


import { useSelector} from 'react-redux';
import { newProduto } from './store/produto.domain';

const { TabPane } = Tabs;

const CamposFormularioCadastroProduto = ({getApi, form, formValueChangeHandler}) => {


    const validateMessages = {
        required: "${label} é obrigatório"
    }
    
    const {firstErrorField } = useSelector(state=>state.produto);
    // const {tabs, setTabs} = useSelector([]);
   

    const [activeKey, setActiveKey] = useState("dados")

    const{produto:dadosProduto} = useSelector(state=>state.produto);
    const produto = newProduto(dadosProduto);


    useEffect(()=> {
       
       
       if(firstErrorField){
           const element = document.getElementById(firstErrorField.id);
           if(element){
               const tab = element.dataset.tab;
               if(tab){
                    setActiveKey(tab);
               }
           }

       }
    }, [firstErrorField]);


   
   

   
    const changeTab = (key) => {
        setActiveKey(key);
    }


    const tabPaneDados = <TabPane tab="Dados" forceRender={true} key="dados">
                            <TabDados form={form} dataTab={"dados"} />
                        </TabPane>

    const tabPaneTributacao = <TabPane tab="Tributação" forceRender={true} key="tributacao">
                                <TabTributacao form={form} dataTab={"tributacao"} getApi={getApi} />
                              </TabPane>
    
    const tabPaneBalanca = <TabPane tab="Balança" key="balanca">
        <TabBalancas dataTab={"balanca"} form={form} />
    </TabPane>
    const tabPaneEstoque = <TabPane tab="Estoque" key="estoque">
        <TabEstoque dataTab={"estoque"} form={form}></TabEstoque>
    </TabPane>
    
    const tabPaneEcommerce = <TabPane tab="E-commerce" key="ecommerce">
        <TabECommerce dataTab={"ecommerce"} form={form} />
    </TabPane>
    const tabPaneNucardapio = <TabPane tab="NuCardapio" key="nucardapio">
        <TabNucardapio form={form} dataTab={"nucardapio"}/>
    </TabPane>
    const tabPaneOutrasInformacoes = <TabPane tab="Outras Informações" key="outrasInformacoes">
        <TabOutrasInformacoes dataTab={"outrasInformacoes"} form={form}></TabOutrasInformacoes>
    </TabPane>


    const tabPaneOpcoesPDV = <TabPane tab="Opcoes PDV" key="opcoesPDV">
        <TabOpcoesPDV dataTab={"opcoesPDV"} form={form}></TabOpcoesPDV>
    </TabPane>


    const tabPaneComposicao = <TabPane tab="Composicao" key="composicao">
                                <TabComposicao form={form} getApi={getApi} dataTab={"composicao"} ></TabComposicao>
                            </TabPane>

    const tabs = [];


    tabs.push(tabPaneDados);

    if(produto.permiteComposicao()){
        tabs.push(tabPaneComposicao);
    }

    tabs.push(
        tabPaneTributacao,
        tabPaneBalanca,
        tabPaneEstoque,
        
        tabPaneEcommerce,
        tabPaneNucardapio,
        tabPaneOutrasInformacoes,
        tabPaneOpcoesPDV
    );



    return <Row>
            <Col sm={24}>
                <Form onValuesChange={formValueChangeHandler} scrollToFirstError={true} layout="vertical" form={form} validateMessages={validateMessages}>
                    <Row>
                        <Col sm={24}>

                            <Form.Item
                                label="Descrição"
                                name="descricao"
                            >
                                <Input size="large"  autoFocus  style={{fontWeight: "bold"}} placeholder="INFORME AQUI A DESCRICAO DO PRODUTO"/>

                            </Form.Item>
                        </Col>
                    </Row>
                    <Row> 
                        <Col sm={24}>
                            <Tabs onChange={changeTab} activeKey={activeKey}>
                                {tabs}
                            
                                
                                
                            </Tabs>
                        </Col>
                    </Row>
                   
                </Form>
            </Col>
        </Row>


}

export { CamposFormularioCadastroProduto }